export const layoutsMisc = {
  confirm: {
    defaultTitle: "Tem certeza?",
    confirm: "Confirmar",
    cancel: "Cancelar",
  },
  navPluginWeb: {
    title: "Criar site",
    stepOf: "{step} de 5",
  },
  saMenu: {
    title: "Ações do sistema",
    subtitle: "Painel de automações",
    sectionComms: "COMUNICAÇÕES",
    firstCheckin: "Enviar no primeiro check-in",
  },
  systemActions: {
    checkin: "Check-in",
  },
  regionMessage: {
    text: "Entre em contato com a equipe de suporte para configurar a conexão.",
    contactSupport: "Falar com o suporte",
  },
  selectionScanner: {
    title: "Escolha o tipo de documento para escanear",
    idCard: "Documento de identidade",
    passport: "Passaporte",
  },
};
